import request, { DELETE } from '../../utils/request';

export default requestId => request(`/pre-settlement-requests/${requestId}`, { method: DELETE });
